import { useTheme } from '../hooks/useTheme';

export function ThemeToggle() {
  const { resolved, setMode } = useTheme();
  const goingDark = resolved !== 'dark';
  const label = goingDark ? 'Switch to dark theme' : 'Switch to light theme';

  return (
    <button
      type="button"
      className="theme-toggle"
      aria-label={label}
      title={label}
      onClick={() => setMode(goingDark ? 'dark' : 'light')}
    >
      <span aria-hidden>{resolved === 'dark' ? '☀' : '☾'}</span>
    </button>
  );
}
